import { sdkRequest } from '@eventbrite/http';
import { sanitizeRedirectUrl } from '../utils/security';
import { getSignupApiData } from '../utils/signup';
import { IFetchJSONErrorProps } from './utils';

export const SIGNUP_URL = '/api/v3/users/';

export interface ISignupUserApiQueryProps {
    [x: string]: string | boolean | number | undefined;

    password: string;
    first_name: string;
    last_name: string;
    email: string;
    forward: string;
    referrer: string;
    pckg: string;
    accepted_tos_by_popup: number;
}

export interface ISignupApiResponseProps {
    redirectUrl?: string;
    success: boolean;
}

export interface ISignupUserBody {
    user: { first_name: string; last_name: string; email: string };
    password: string;
    auto_subscribe: boolean;
    verification_code?: string;
}
interface ISignupApiRawResponseProps {
    redirect_url?: string;
    success: true;
}

export const signupUser = ({
    data,
    verificationCode,
}: {
    data: ISignupUserApiQueryProps;
    useVerificationCode?: boolean;
    verificationCode?: string;
}) => {
    const body: ISignupUserBody = getSignupApiData({ data, verificationCode });

    return sdkRequest(SIGNUP_URL, {
        method: 'POST',
        body: JSON.stringify(body),
    })
        .then((response: ISignupApiRawResponseProps) => {
            const _response: ISignupApiResponseProps = {
                redirectUrl: sanitizeRedirectUrl(response?.['redirect_url']),
                success: response?.success,
            };

            return _response;
        })
        .catch((error: IFetchJSONErrorProps) => {
            // Return the error as a parseed error or an empty object to prevent failures
            throw error.errors || {};
        });
};
